import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export default class TaskChecklistItemModel extends Model {
  @attr('string') label!: string;
  @attr('string') section?: string;
  @attr('string') instructions?: string | null;
  @attr('number') position!: number;
  @attr('boolean') required!: boolean;
  @attr('boolean') requiresPhoto!: boolean;
  @attr('string') note?: string | null;
  @attr('string') completedAt?: string;
  @attr('boolean') completed!: boolean;
  @attr('string') completedByUserId?: string;

  @attr('string') taskId?: string;

  @cached
  get isCompleted(): boolean {
    return this.completed;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'task-checklist-item': TaskChecklistItemModel;
  }
}
